/**
 * Die Preisautomatik-Schicht für Grundkalender und Monat. Ohne Anbieter – für Rollen ohne
 * Preisautomatik – gibt es keine Schicht und keine Anfrage; die Flächen zeigen dann nur V&V.
 * Scheitert das Laden, trägt der Status den Grund, damit eine leere Schicht nicht wie „nichts
 * offen“ aussieht.
 */
import { createContext, useContext, type ReactNode } from 'react';
import type { AutomationLayer } from './automationModel';

export interface AutomationStatus {
  message: string;
  /** Die zuletzt geladene Schicht steht noch – nur das Nachladen scheiterte. */
  stale: boolean;
  retrying: boolean;
  retry: () => void;
}

const LayerContext = createContext<AutomationLayer | null>(null);
const StatusContext = createContext<AutomationStatus | null>(null);

export function AutomationLayerProvider({
  layer,
  status = null,
  children,
}: {
  layer: AutomationLayer | null;
  status?: AutomationStatus | null;
  children: ReactNode;
}) {
  return (
    <LayerContext.Provider value={layer}>
      <StatusContext.Provider value={status}>{children}</StatusContext.Provider>
    </LayerContext.Provider>
  );
}

export function useAutomationLayer(): AutomationLayer | null {
  return useContext(LayerContext);
}

export function useAutomationStatus(): AutomationStatus | null {
  return useContext(StatusContext);
}
